module.exports = __webpack_public_path__ + "src/assets/img/car.3836f9e8.svg";